import * as React from "react";

const PlayIcon: React.FC = () => {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="presentation"
        >
            <path
                d="M19.9997 36.6666C29.2044 36.6666 36.6663 29.2047 36.6663 20C36.6663 10.7952 29.2044 3.33331 19.9997 3.33331C10.7949 3.33331 3.33301 10.7952 3.33301 20C3.33301 29.2047 10.7949 36.6666 19.9997 36.6666Z"
                fill="#323132"
                fill-opacity="0.78"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path d="M16.667 13.3333L26.667 20L16.667 26.6666V13.3333Z" fill="white" />
        </svg>
    );
};

export default React.memo(PlayIcon);
